import type { HblPage } from '@/utils/types'
import {
    hblMapCategory,
    hblCategoryIncludes,
    hblMapBreadcrumb,
    hblMapProduct,
    hblProductIncludes,
    hblMapSections,
    hblSectionIncludes
} from '#imports'

export const hblPageIncludes = {
    'pwa_page_result': [
        'resourceIdentifier',
        'canonicalPathInfo',
        'resourceType',
        'cmsPage',
        'breadcrumb',
        'product',
        'configurator',
        'category',
        'post',
        'extensions',
        'landingPage',
    ],
    'cms_page': [
        'name',
        'sections',
    ],
    'landing_page': [
        'id',
        'active',
        'translated',
        'name',
        'description',
        'metaTitle',
        'metaDescription',
        'seoUrls',
    ],
    ...hblSectionIncludes,
    ...hblProductIncludes,
    ...hblCategoryIncludes
}

export function hblMapPage (swPage: any): HblPage {
    const obj = {
        id: swPage.resourceIdentifier,
        canonicalUrl: swPage.canonicalPathInfo,
        type: swPage.resourceType,
        structure: null
    }

    if (swPage.resourceType === 'frontend.navigation.page') {
        Object.assign(obj, { type: 'category' })
    }

    if (swPage.resourceType === 'frontend.detail.page') {
        Object.assign(obj, { type: 'detail' })
    }

    if (swPage.resourceType === 'frontend.landing.page') {
        Object.assign(obj, { type: 'cms' })
    }

    if (swPage.resourceType === 'frontend.blog.post.view') {
        Object.assign(obj, { type: 'post' })
    }

    if (swPage.cmsPage != null) {
        // @ts-ignore
        obj.structure = hblMapSections(swPage.cmsPage?.sections)

        Object.assign(obj, {
            cms: {
                id: swPage.extensions?.landingPage?.id,
                // @ts-ignore
                active: swPage.extensions?.landingPage?.active,
                name: swPage.extensions?.landingPage?.translated?.name,
                // @ts-ignore
                description: swPage.extensions?.landingPage?.translated?.description,
                // @ts-ignore
                metaTitle: swPage.extensions?.landingPage?.metaTitle,
                // @ts-ignore
                metaDescription: swPage.extensions?.landingPage?.metaDescription,
                url: swPage.extensions?.landingPage?.seoUrls?.[0].seoPathInfo.startsWith('/') ? swPage.extensions?.landingPage?.seoUrls?.[0].seoPathInfo : '/' + swPage.extensions?.landingPage?.seoUrls?.[0].seoPathInfo,
                pathInfo: `/navigation/${swPage.extensions?.landingPage?.id}`

            }
        })
    }

    if (swPage.breadcrumb !== undefined) {
        Object.assign(obj, { breadcrumb: hblMapBreadcrumb(swPage.breadcrumb) })
    }

    if (swPage.product != null) {
        Object.assign(obj, {
            detail: hblMapProduct(
                swPage.product,
                swPage.configurator != null ? swPage.configurator : null
            )
        })
    }

    if (swPage.post != null) {
        Object.assign(obj, { cms: { post: swPage.post } })
    }

    if (swPage.category != null) {
        Object.assign(obj, { category: hblMapCategory(swPage.category) })
    }

    return obj
}
